import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';


const skillList = {

  item: [
    {name: 'CSS3', 
    images: <FontAwesomeIcon icon = {["fab", "fa-css3-alt"]} />, 
    id: 5483, 
    description: 'CSS3'
  },

  ]
}

  export default skillList;